export function assert(value, message, errorConstructor) {
    if (!value) {
        if (message instanceof Error) {
            throw message;
        }
        else if (errorConstructor) {
            throw new errorConstructor(message);
        }
        throw new Error(message);
    }
}
//# sourceMappingURL=assert.js.map